import {createEntityThunks} from 'utils/createEntityThunks';
import {Client} from 'types/client';
import {ClientService} from 'services/clientsService';
import {createAsyncThunk} from '@reduxjs/toolkit';

const clientFactory = (data: any) => new Client(data);

class BaseClientsThunks extends createEntityThunks<Client>(
  'client',
  ClientService,
  {activate: true, deactivate: true},
  clientFactory,
) {}

export class ClientThunks extends BaseClientsThunks {
}
